import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { FolderShare } from '../../../class/folder-share';
import { FolderShareService } from '../../../service/folder-share/folder-share.service';
import { TranslateService } from '@ngx-translate/core';
import { Message, SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-folder-share',
  templateUrl: './new-folder-share.component.html',
  styleUrls: ['./new-folder-share.component.scss']
})
export class NewFolderShareComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: FolderShare;

    messages: Message[] = [];

    public promiseForm: Promise<any>;
    public form: FormGroup;

    public employee_id: AbstractControl ;
    public candidate_id: AbstractControl ;
    public department_origin_id: AbstractControl ;
    public department_id: AbstractControl ;
    public start_date: AbstractControl ;
    public end_date: AbstractControl ;
    public es: any;

    public modViewDialog: boolean;

    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public archiveService: FolderShareService,
        public translate: TranslateService,
        private notificationsService: NotificationsService) {
        this.modViewDialog = false;

        this.save_exit = false;

        this.es = calendarES();
        
        this.form = fb.group({
            'employee_id': ['', Validators.compose([Validators.required])],
            'candidate_id': ['', Validators.compose([Validators.required])],
            'department_origin_id': ['', Validators.compose([Validators.required])],
            'department_id': ['', Validators.compose([Validators.required])],
            'start_date': [''],
            'end_date': [''],
        });

        this.employee_id = this.form.controls['employee_id'];
        this.candidate_id = this.form.controls['candidate_id'];
        this.department_origin_id = this.form.controls['department_origin_id'];
        this.department_id = this.form.controls['department_id'];
        this.start_date = this.form.controls['start_date'];
        this.end_date = this.form.controls['end_date'];
    }

    ngOnInit() {
        if (this.edit) {
            this.employee_id.setValue(this.edit.employee_id);
            this.candidate_id.setValue(this.edit.candidate_id);
            this.department_origin_id.setValue(this.edit.department_origin_id);
            this.department_id.setValue(this.edit.department_id);
            if (this.edit.start_date) {
                this.start_date.setValue(new Date(this.edit.start_date));
            }
            if (this.edit.end_date) {
                this.end_date.setValue(new Date(this.edit.end_date));
            }
        } else {
            // this.activated.setValue(true);
        }
    }

    public cancelFolderShare () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newFolderShare(values);
    }

    public newFolderShare(values) {
        const param = {
            'employee_id': values.employee_id.id,
            'candidate_id': values.candidate_id.id,
            'department_origin_id': values.department_origin_id,
            'department_id': values.department_id,
            'start_date': values.start_date,
            'end_date': values.end_date,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.archiveService.updateFolderShare(this.edit.id, param)
                :
                this.archiveService.newFolderShare(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    public showNewCandidateDialog() {
        this.modViewDialog = true;
    }

    public showResultNewCandidate(msg) {
        this.messages = [];
        this.messages.push(msg);
    }

    public cancelNewCandidate() {
        this.modViewDialog = false;
    }

    // public formatDate(date) {
    //     const d = new Date(date);
    //     let month = '' + (d.getMonth() + 1);
    //     let day = '' + d.getDate();
    //     const year = d.getFullYear();
    //     let hours = '' + d.getHours();
    //     let minutes = '' + d.getMinutes();
    //     let seconds = '' + d.getSeconds();

    //     if (month.length < 2) {
    //         month = '0' + month;
    //     }
    //     if (day.length < 2) {
    //         day = '0' + day;
    //     }

    //     if (hours.length < 2) {
    //         hours = '0' + hours;
    //     }

    //     if (minutes.length < 2) {
    //         minutes = '0' + minutes;
    //     }

    //     if (seconds.length < 2) {
    //         seconds = '0' + seconds;
    //     }

    //     return [year, month, day].join('-');
    // }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/folder-shares/new-folder-share/new-folder-share.component.ts